// Libs
import React from 'react';
import { useI18next, useTranslation } from 'gatsby-plugin-react-i18next';
// styless
import './getYourQuote.scss';
import { handleGetYourQuoteClick } from '../../helpers/getYourQuote.helper';

const GetYourQuote = ({ isOnNavbar, yellow = false, trackingClass = '' }) => {
  const { t } = useTranslation();
  const { language } = useI18next();
  const handleClick = React.useCallback(() => {
    const action = isOnNavbar ? 'Click-navbar' : 'Click';
    window.dataLayer.push({
      event: 'GetYourQuoteClick',
      eventCategory: 'GetYourQuote',
      eventAction: action,
    });
    handleGetYourQuoteClick(language);
  }, []);

  return (
    <div id="getYourQuote">
      <div
        role="button"
        className={`quoteButtonYellow trackingCTA trackingButton ${trackingClass}`}
        onClick={handleClick}
        onKeyUp={handleClick}
      >
        {yellow ? t('Get Your Free Quote') : t('Get Your quote')}
      </div>
    </div>
  );
};

export default GetYourQuote;
